import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import MasterLayout from "./masterLayout/MasterLayout";
import PrivateRoute from "./routes/PrivateRoute";
import { LoaderProvider } from "./context/LoaderContext";

import Login from "./pages/Auth/Login";
import Dashboard from "./pages/Dashboard/DashBoard";
import Users from "./pages/Users/users";
import RoleAccess from "./pages/Users/RoleAccess";
import Modules from "./pages/Users/Modules";
import GamesList from "./pages/Games/GamesList";
import BildirimMailGonder from "./pages/Notifications/BildirimMailGonder";
import AllPayments from "./pages/Payments/AllPayments";
import IbanInformation from "./pages/Payments/IbanInformation";
import Marketplace from "./pages/Marketplace/Marketplace";
import Dictionary from "./pages/Dictionary/Dictionary";
import Rankings from "./pages/Rankings/Rankings";
import SmtpSettings from "./pages/Smtp/SmtpSettings";


function App() {
  return (
    <BrowserRouter>
      <LoaderProvider>
        <Toaster position="top-right" />

        <Routes>

          {/* ROOT -> LOGIN REDIRECT */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* LOGIN PAGE */}
          <Route path="/login" element={<Login />} />

          {/* PROTECTED ROUTES */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <Dashboard />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          {/* Users */}
          <Route
            path="/kullanıcılar"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <Users />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          {/* OYUNLAR */}
          <Route
            path="/oyunlar"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <GamesList />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          {/* BİLDİRİM VE MAİL GÖNDER */}
          <Route
            path="/BildirimMailGonder"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <BildirimMailGonder />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          {/* ÖDEMELER */}
          <Route
            path="/tum-odemeler"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <AllPayments />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/iban-bilgileri"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <IbanInformation />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          {/* PAZARYERİ - PREMIUM PLANLAR */}
          <Route
            path="/pazaryeri"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <Marketplace />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          {/* SÖZLÜK */}
          <Route
            path="/sozluk"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <Dictionary />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          {/* PUAN SIRALAMASI */}
          <Route
            path="/puan-siralamasi"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <Rankings />
                </MasterLayout>
              </PrivateRoute>
            }
          />

          {/* SMTP AYARLARI */}
          <Route
            path="/SMTP"
            element={
              <PrivateRoute>
                <MasterLayout>
                  <SmtpSettings />
                </MasterLayout>
              </PrivateRoute>
            }
          />

        </Routes>

      </LoaderProvider>
    </BrowserRouter>
  );
}

export default App;
